/*
 * Chasse aux citrouilles (Halloween).
 * - À chaque page chargée, une citrouille peut apparaître à un endroit aléatoire (probabilité réglable).
 * - Un clic la collecte ; la progression est mémorisée sur l'appareil (localStorage).
 * - Quand le nombre demandé est atteint, un message de réussite affiche le(s) code(s) promo.
 * Réglages : Personnaliser le thème > Paramètres du thème > Chasse aux citrouilles.
 */
(function () {
  var cfgEl = document.getElementById('pumpkin-hunt-config');
  if (!cfgEl || window.__pumpkinHuntBound) return;
  window.__pumpkinHuntBound = true;

  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!cfg || !cfg.enabled) return;

  var KEY = 'cdp-pumpkins-v1';
  var params = new URLSearchParams(window.location.search);
  var testParam = cfg.testMode ? params.get('citrouille') : null;

  function load() {
    try { return JSON.parse(window.localStorage.getItem(KEY)) || {}; } catch (e) { return {}; }
  }
  function save(s) {
    try { window.localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) { /* stockage indisponible */ }
  }
  if (testParam === 'reset') {
    try { window.localStorage.removeItem(KEY); } catch (e) { /* ignoré */ }
  }

  function parisToday() {
    try {
      return new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit'
      }).format(new Date());
    } catch (e) {
      return new Date().toISOString().slice(0, 10);
    }
  }
  var today = parisToday();
  var datePattern = /^\d{4}-\d{2}-\d{2}$/;
  if (datePattern.test(cfg.startDate) && today < cfg.startDate) return;
  if (datePattern.test(cfg.endDate) && today > cfg.endDate) return;

  var goal = Math.max(1, parseInt(cfg.goal, 10) || 5);
  var state = load();
  state.found = Math.min(parseInt(state.found, 10) || 0, goal);
  var done = state.found >= goal;
  if (done && !state.codes) state.codes = pickCodes();

  function cleanCodes() {
    var seen = {};
    return (cfg.codes || []).map(function (c) { return String(c).trim(); }).filter(function (c) {
      var key = c.toUpperCase();
      if (!c || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }
  function pickCodes() {
    var all = cleanCodes();
    if (!all.length) return [];
    if (cfg.codesMode === 'all') return all;
    return [all[Math.floor(Math.random() * all.length)]];
  }

  // ---------- icônes ----------
  var PUMPKIN_SVG =
    '<svg viewBox="0 0 64 64" aria-hidden="true" focusable="false">' +
    '<path d="M32 17c-2-7 1-11 7-13" fill="none" stroke="#4d6b27" stroke-width="4" stroke-linecap="round"/>' +
    '<ellipse cx="19" cy="38" rx="13" ry="20" fill="#cf5a0d"/>' +
    '<ellipse cx="45" cy="38" rx="13" ry="20" fill="#cf5a0d"/>' +
    '<ellipse cx="32" cy="38" rx="15" ry="22" fill="#f08a24"/>' +
    '<ellipse cx="26" cy="28" rx="4" ry="9" fill="#ffb15a" opacity="0.6"/>' +
    '<path d="M21 34l6 0-3-7z M37 34l6 0-3-7z" fill="#3b1f10"/>' +
    '<path d="M22 42l4 4 3-3 3 4 3-4 3 3 4-4q-10 12-20 0z" fill="#3b1f10"/>' +
    '</svg>';

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function fill(template, values) {
    return String(template || '').replace(/\{(\w+)\}/g, function (m, key) {
      return values[key] !== undefined ? values[key] : m;
    });
  }

  // ---------- compteur ----------
  var counter = null;
  var counterText = null;
  var dotsBox = null;

  function counterLabel() {
    var values = { found: state.found, total: goal };
    if (done && cfg.texts.counterDone) return fill(cfg.texts.counterDone, values);
    if (state.found === 1 && cfg.texts.counterOne) return fill(cfg.texts.counterOne, values);
    return fill(cfg.texts.counter, values);
  }

  function buildCounter() {
    counter = el('div', 'pk-counter');
    counter.setAttribute('data-template', cfg.template || '');
    var icon = el('span', 'pk-counter__icon');
    icon.innerHTML = PUMPKIN_SVG;
    counterText = el('span', 'pk-counter__text');
    counterText.setAttribute('aria-live', 'polite');
    dotsBox = el('span', 'pk-counter__dots');
    dotsBox.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < goal; i++) dotsBox.appendChild(el('span', 'pk-dot'));
    counter.appendChild(icon);
    counter.appendChild(counterText);
    if (goal <= 10) counter.appendChild(dotsBox);
    counter.addEventListener('click', function () { if (done) openReward(); });
    counter.addEventListener('keydown', function (e) {
      if (done && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); openReward(); }
    });
    document.body.appendChild(counter);
    updateCounter(false);
  }

  function updateCounter(pulse) {
    if (!counter) return;
    counterText.textContent = counterLabel();
    var dots = dotsBox.children;
    for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-on', i < state.found);
    counter.classList.toggle('is-done', done);
    if (done) {
      counter.setAttribute('role', 'button');
      counter.setAttribute('tabindex', '0');
    }
    counter.hidden = !(cfg.showFromStart || state.found > 0);
    if (pulse) {
      counter.classList.remove('is-pulse');
      void counter.offsetWidth;
      counter.classList.add('is-pulse');
    }
  }

  // ---------- message bref ----------
  var toast = null;
  var toastTimer = null;
  function showToast(message, duration) {
    if (!message) return;
    if (!toast) {
      toast = el('div', 'pk-toast');
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, duration || 2800);
  }

  // ---------- message de réussite ----------
  var modal = null;
  function copyText(value, button) {
    var finish = function () {
      var label = button.textContent;
      button.textContent = cfg.texts.copied || 'Copié !';
      setTimeout(function () { button.textContent = label; }, 1600);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(value).then(finish, finish);
      return;
    }
    var field = document.createElement('textarea');
    field.value = value;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();
    try { document.execCommand('copy'); } catch (e) { /* ignoré */ }
    document.body.removeChild(field);
    finish();
  }

  function closeReward() {
    if (modal) modal.hidden = true;
    document.removeEventListener('keydown', onKey);
  }
  function onKey(e) { if (e.key === 'Escape') closeReward(); }

  function openReward() {
    if (modal) modal.parentNode.removeChild(modal);
    modal = el('div', 'pk-modal');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.addEventListener('click', function (e) { if (e.target === modal) closeReward(); });

    var card = el('div', 'pk-modal__card');
    var confetti = el('div', 'pk-confetti');
    for (var i = 0; i < 14; i++) {
      var piece = el('span');
      piece.innerHTML = PUMPKIN_SVG;
      piece.style.left = (i * 7.3 + 2) % 96 + '%';
      piece.style.animationDelay = (i * 0.23) + 's';
      piece.style.animationDuration = (2.8 + (i % 4) * 0.5) + 's';
      confetti.appendChild(piece);
    }
    card.appendChild(confetti);

    var close = el('button', 'pk-modal__close', '×');
    close.type = 'button';
    close.setAttribute('aria-label', cfg.texts.close || 'Fermer');
    close.addEventListener('click', closeReward);
    card.appendChild(close);

    var big = el('div', 'pk-modal__pumpkin');
    big.innerHTML = PUMPKIN_SVG;
    card.appendChild(big);
    card.appendChild(el('h2', 'pk-modal__title', fill(cfg.texts.rewardTitle, { total: goal })));
    card.appendChild(el('p', 'pk-modal__text', fill(cfg.texts.rewardText, { total: goal })));

    var codes = state.codes || [];
    var codesBox = el('div', 'pk-modal__codes');
    codes.forEach(function (code) {
      var row = el('div', 'pk-code');
      row.appendChild(el('span', 'pk-code__value', code));
      var copy = el('button', 'pk-btn', cfg.texts.copy || 'Copier');
      copy.type = 'button';
      copy.addEventListener('click', function () { copyText(code, copy); });
      row.appendChild(copy);
      if (cfg.applyButton) {
        var isGift = !!(window.cdpGiftCode && window.cdpGiftCode.isGiftCode(code));
        var label = isGift ? (cfg.giftApplyLabel || 'Choisir ma crème mains offerte') : (cfg.applyLabel || 'Utiliser mon code');
        var apply = el('button', 'pk-btn pk-btn--solid', label);
        apply.type = 'button';
        apply.addEventListener('click', function () { useCode(code, isGift, apply); });
        row.appendChild(apply);
      }
      codesBox.appendChild(row);
    });
    card.appendChild(codesBox);

    var actions = el('div', 'pk-modal__actions');
    var closeBtn = el('button', 'pk-btn', cfg.texts.close || 'Fermer');
    closeBtn.type = 'button';
    closeBtn.addEventListener('click', closeReward);
    actions.appendChild(closeBtn);
    card.appendChild(actions);

    modal.appendChild(card);
    document.body.appendChild(modal);
    document.addEventListener('keydown', onKey);
    closeBtn.focus();
  }

  // ---------- utilisation du code ----------
  var NOTE_KEY = 'cdp-pumpkins-note';
  function redirectUrl() { return cfg.redirect || ((cfg.root || '/') + 'collections/noel'); }
  function setNote(type, code) {
    try { window.sessionStorage.setItem(NOTE_KEY, JSON.stringify({ type: type, code: code })); } catch (e) { /* ignoré */ }
  }

  function useCode(code, isGift, button) {
    if (!isGift) {
      // code ordinaire : Shopify l'enregistre pour le panier / le paiement, puis on envoie le client sur la collection
      setNote('applied', code);
      // le thème retient les codes appliqués dans ce cookie : on y ajoute le nôtre pour qu'un autre code saisi ensuite ne l'écrase pas
      try {
        var m = document.cookie.match('(^|;)\\s*eurus_discount_code\\s*=\\s*([^;]+)');
        var list = m ? m.pop().split(',') : [];
        if (list.indexOf(code) === -1) list.push(code);
        document.cookie = 'eurus_discount_code=' + list.join(',') + '; path=/';
      } catch (e) { /* ignoré */ }
      window.location.href = (cfg.root || '/') + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirectUrl());
      return;
    }
    // code "crème mains offerte" : même fenêtre de choix que dans le panier
    button.disabled = true;
    window.cdpGiftCode.open(code, { silentNeedsProduct: true }).then(function (result) {
      button.disabled = false;
      if (result === 'needs-product') {
        // la crème n'est offerte qu'avec au moins un autre produit : direction la collection
        setNote('gift-pending', code);
        window.location.href = redirectUrl();
        return;
      }
      if (result === 'picker' || result === 'applied') closeReward();
    });
  }

  function showNote() {
    var raw = null;
    try { raw = window.sessionStorage.getItem(NOTE_KEY); window.sessionStorage.removeItem(NOTE_KEY); } catch (e) { /* ignoré */ }
    if (!raw) return;
    var note;
    try { note = JSON.parse(raw); } catch (e) { return; }
    if (note.type === 'applied') {
      // le code est enregistré par Shopify ; on vérifie s'il s'applique déjà au contenu du panier
      fetch((cfg.root || '/') + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var entry = (data.discount_codes || []).filter(function (c) { return String(c.code).toUpperCase() === String(note.code).toUpperCase(); })[0];
          var ok = !entry || entry.applicable;
          showToast(fill(ok ? cfg.texts.applied : cfg.texts.saved, { code: note.code }), 7000);
        })
        .catch(function () { showToast(fill(cfg.texts.applied, { code: note.code }), 6000); });
    }
    else if (note.type === 'gift-pending') showToast(cfg.texts.giftPending, 8000);
  }
  document.addEventListener('cdp:gift-code:applied', function () { showToast(cfg.texts.giftAdded, 5000); });

  // ---------- citrouille cachée ----------
  function isExcluded() {
    var path = window.location.pathname;
    var root = cfg.root || '/';
    if (root !== '/' && path.indexOf(root) === 0) path = '/' + path.slice(root.length);
    var list = (cfg.excluded || []).map(function (p) { return String(p).trim(); }).filter(Boolean);
    return list.some(function (p) {
      if (p.charAt(0) !== '/') p = '/' + p;
      return path === p || path.indexOf(p.replace(/\/$/, '') + '/') === 0;
    });
  }

  function spawn() {
    var size = parseInt(cfg.size, 10) || 56;
    var docHeight = Math.max(
      document.documentElement.scrollHeight, document.body.scrollHeight, window.innerHeight
    );
    var docWidth = document.documentElement.clientWidth;

    var layer = el('div', 'pk-layer');
    layer.style.height = docHeight + 'px';

    var pumpkin = el('button', 'pk-pumpkin');
    pumpkin.type = 'button';
    pumpkin.setAttribute('aria-label', cfg.texts.pumpkinLabel || 'Citrouille cachée');
    pumpkin.style.width = size + 'px';
    pumpkin.style.height = size + 'px';
    if (cfg.image) {
      var img = document.createElement('img');
      img.src = cfg.image;
      img.alt = '';
      pumpkin.appendChild(img);
    } else {
      pumpkin.innerHTML = PUMPKIN_SVG;
    }

    var minY = 140;
    var maxY = Math.max(minY + 1, docHeight - size - 24);
    var x = 8 + Math.random() * Math.max(1, docWidth - size - 16);
    var y = minY + Math.random() * (maxY - minY);
    pumpkin.style.left = Math.round(x) + 'px';
    pumpkin.style.top = Math.round(y) + 'px';

    pumpkin.addEventListener('click', function () { collect(pumpkin, layer); });
    layer.appendChild(pumpkin);
    document.body.appendChild(layer);

    if (testParam === '1') {
      // mode test : amener la citrouille à l'écran pour la voir tout de suite
      window.scrollTo(0, Math.max(0, y - window.innerHeight / 2));
    }
  }

  function collect(pumpkin, layer) {
    if (done) return;
    pumpkin.classList.add('is-collected');
    state.found = Math.min(goal, state.found + 1);
    done = state.found >= goal;
    if (done) state.codes = pickCodes();
    save(state);
    updateCounter(true);
    setTimeout(function () { if (layer.parentNode) layer.parentNode.removeChild(layer); }, 600);
    if (done) {
      setTimeout(openReward, 800);
    } else {
      showToast(fill(cfg.texts.found, { found: state.found, total: goal }));
    }
  }

  function init() {
    buildCounter();
    showNote();
    if (done || !cfg.eligible || isExcluded()) return;
    var forced = testParam === '1';
    var rate = Math.max(0, Math.min(100, parseFloat(cfg.rate) || 0));
    if (!forced && Math.random() * 100 >= rate) return;
    // laisser la page se mettre en place pour connaître sa hauteur réelle
    var run = function () { setTimeout(spawn, 400); };
    if (document.readyState === 'complete') run();
    else window.addEventListener('load', run);
  }

  if (document.body) init();
  else document.addEventListener('DOMContentLoaded', init);
})();
